export const ONE_MINUTE_IN_MILLISECONDS = 1000 * 60 * 1;
export const TWO_MINUTES_IN_MILLISECONDS = 1000 * 60 * 2;
export const THREE_MINUTES_IN_MILLISECONDS = 1000 * 60 * 3;
export const TWO_HOURS_IN_MILLISECONDS = 1000 * 60 * 60 * 2;
export const ONE_DAY_IN_MILLISECONDS = 1000 * 60 * 60 * 24;
